import React, { useEffect, useState } from "react";
import { supabase } from "../../client";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";
import ProductCard from "../ProductCard";

const Shop = ({ addToCart, cart, updateItem, removeItem, removeFromCart }) => {
  const [product, setProduct] = useState([]);

  const getProduct = async (e) => {
    const products = (await supabase.from("products").select().limit(20)).data;
    setProduct(products);
  };

  useEffect(() => {
    getProduct();
  }, []);
  return (
    <LargeContainer>
      <MainContainer>
        {product.map((p) => (
          <ProductCard
            key={p.id}
            product={p}
            addToCart={addToCart}
            cart={cart}
            removeFromCart={removeFromCart}
            width="25%"
          />
        ))}
      </MainContainer>
    </LargeContainer>
  );
};

export default Shop;
